// File: src/components/GlobalDeliverySuccess.tsx
import React from 'react';
import '../styles/GlobalDeliverySuccess.css';

const GlobalDeliverySuccess: React.FC = () => {
  return (
    <section className="global-delivery-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Worldwide Delivery & Happy Families</h2>
          <div className="section-subtitle">
            We've delivered puppies to happy families across the globe with our safe,
            reliable transportation network
          </div>
        </div>

        <div className="delivery-stats">
          <div className="stat-card">
            <div className="stat-value">2,500+  Puppies Delivered</div>
            <div className="stat-label"></div>
          </div>
          <div className="stat-card">
            <div className="stat-value">98.7% Success Rate</div>
            <div className="stat-label"></div>
          </div>
          <div className="stat-card">
            <div className="stat-value">45+  Countries Served</div> 
            <div className="stat-label"></div>
          </div>
        </div>

        <div className="customer-showcase">
          <div className="showcase-content">
            <h3>Meet Our Happy Families</h3>
            <p>
              "We were nervous about international delivery, but the team kept us updated at every step.
              When Milo arrived, he was happy, healthy, and already felt like part of our family!"
            </p>
            <div className="customer-info">
              <div className="customer-name">- Sarah & James, London</div>
              <div className="delivery-info">Delivered from New York to UK in 18 hours</div>
            </div>
          </div>
          
          <div className="showcase-images">
            <div className="image-grid">
              <div className="image-card">
                <img src={require('../resources/banner.jpg')} alt="Happy customer with puppy" />
                <div className="image-caption">Tokyo, Japan</div>
              </div>
              <div className="image-card">
                <img src={require('../resources/banner.jpg')} alt="Puppy delivery" />
                <div className="image-caption">Paris, France</div>
              </div>
              <div className="image-card">
                <img src={require('../resources/banner.jpg')} alt="Customer receiving puppy" />
                <div className="image-caption">Sydney, Australia</div>
              </div>
              <div className="image-card">
                <img src={require('../resources/dog13.jpg')} alt="Family with new puppy" />
                <div className="image-caption">Toronto, Canada</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalDeliverySuccess;